import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { ValidateDialogData } from '@app/shared/components/dialogs/validate-dialog/validate-dialog.data';

@Component({
    selector : 'validate-dialog',
    template: require('./validate-dialog.component.html'),
    styles: [require('./validate-dialog.component.scss')]
})
export class ValidateDialogComponent {
    public byActionList;
    constructor(@Inject(MAT_DIALOG_DATA) public data: ValidateDialogData) {
        this.onActionSelected(data.selectedAction);
    }

    public onActionSelected(type): void {
        this.byActionList = type.replace(' ', '') === 'ByPackage' ? this.data.packages : this.data.labels;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/validate-dialog/validate-dialog.component.ts